<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { ContactUsStep, contactUsForm } from '../config/store';
  import { onDestroy, onMount } from 'svelte';
  import { ArrowButton } from '@shared/ui/buttons/arrow-button';

  let timeOut: ReturnType<typeof setTimeout>;

  onMount(() => {
    timeOut = setTimeout(() => {
      contactUsForm.updateStep(ContactUsStep.First);
    }, 5000);
  });

  onDestroy(() => {
    clearTimeout(timeOut);
  });
</script>

<div
  class="border-default-300 mx-auto flex w-full max-w-[700px] flex-col items-center justify-center gap-10 rounded-3xl border py-24 md:px-10 lg:px-20"
>
  <Icon name="success" width="{44}" height="{44}" />

  <p class="px-2 text-center text-4xl font-medium">The request has been <br /> successfully saved.</p>

  <p class="px-5 text-center text-base">Thank you for your interest! <br /> We will contact you a bit later.</p>

  <div class="w-[192px]">
    <ArrowButton
      variant="third"
      classes="text-lg mx-auto leading-[18px] py-[14px] justify-center"
      hugged="{true}"
      on:click="{() => contactUsForm.updateStep(ContactUsStep.First)}"
    >
      Close
    </ArrowButton>
  </div>
</div>
